import { Link } from "react-router-dom";

export default function NotFound(): JSX.Element {
  return (
    <div
      data-testid="page-ready"
      className="flex h-full flex-col items-center justify-center gap-4"
    >
      <h1 className="text-4xl font-bold text-text-primary">404</h1>
      <p className="text-text-secondary">This workspace doesn&apos;t exist.</p>
      <div className="flex flex-col items-center gap-2">
        <Link
          to="/auth/signup"
          className="text-sm font-medium text-accent-primary underline hover:text-text-secondary"
        >
          Create a new account
        </Link>
        <Link
          to="/login"
          className="text-sm text-text-tertiary underline hover:text-text-secondary"
        >
          Enter a different workspace URL
        </Link>
      </div>
    </div>
  );
}
